import * as React from "react";
import type { SVGProps } from "react";
const SvgNicaragua = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1280 720"
    {...props}
  >
    <defs>
      <linearGradient
        id="Nicaragua_svg__linear-gradient"
        x1={1366.32}
        x2={1579.74}
        y1={253.95}
        y2={253.95}
        gradientTransform="matrix(.97 0 0 .58 -748.44 224.31)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#025" />
        <stop offset={0.5} stopColor="#04a" />
        <stop offset={1} stopColor="#025" />
      </linearGradient>
      <linearGradient
        xlinkHref="#Nicaragua_svg__linear-gradient"
        id="Nicaragua_svg__linear-gradient-2"
        x1={1337.08}
        x2={1576.87}
        y1={444.27}
        y2={444.27}
        gradientTransform="matrix(.95 0 0 .91 -696.13 -23.66)"
      />
      <linearGradient
        id="Nicaragua_svg__linear-gradient-3"
        x1={1035.83}
        x2={1035.83}
        y1={440.11}
        y2={453.27}
        gradientTransform="matrix(.54 0 0 .54 114.42 136.38)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#f5f549" />
        <stop offset={1} stopColor="#97c924" />
      </linearGradient>
      <linearGradient
        xlinkHref="#Nicaragua_svg__linear-gradient-3"
        id="Nicaragua_svg__linear-gradient-4"
        x1={1034.99}
        x2={1034.99}
        y1={440.11}
        y2={453.27}
        gradientTransform="matrix(.54 0 0 .54 99.09 136.38)"
      />
      <linearGradient
        xlinkHref="#Nicaragua_svg__linear-gradient-3"
        id="Nicaragua_svg__linear-gradient-5"
        x1={1029.36}
        x2={1029.36}
        y1={440.11}
        y2={453.27}
        gradientTransform="matrix(.54 0 0 .54 83.76 136.38)"
      />
      <linearGradient
        xlinkHref="#Nicaragua_svg__linear-gradient-3"
        id="Nicaragua_svg__linear-gradient-6"
        x1={1023.76}
        x2={1023.76}
        y1={440.11}
        y2={453.27}
        gradientTransform="matrix(.54 0 0 .54 68.53 136.38)"
      />
      <linearGradient
        xlinkHref="#Nicaragua_svg__linear-gradient-3"
        id="Nicaragua_svg__linear-gradient-7"
        x1={1022.96}
        x2={1022.96}
        y1={440.11}
        y2={453.27}
        gradientTransform="matrix(.54 0 0 .54 53.1 136.38)"
      />
      <linearGradient
        xlinkHref="#Nicaragua_svg__linear-gradient"
        id="Nicaragua_svg__linear-gradient-8"
        x1={970.3}
        x2={1247.82}
        y1={489.55}
        y2={489.55}
        gradientTransform="matrix(.55 0 0 .55 32.45 127.73)"
      />
      <linearGradient
        xlinkHref="#Nicaragua_svg__linear-gradient"
        id="Nicaragua_svg__linear-gradient-9"
        x1={-6714.54}
        x2={-5480.64}
        y1={2658.85}
        y2={2658.85}
        gradientTransform="matrix(.11 0 0 -.11 1327.66 691.78)"
      />
      <linearGradient
        id="Nicaragua_svg__linear-gradient-10"
        x1={1239.94}
        x2={1242.82}
        y1={965.47}
        y2={973.94}
        gradientTransform="matrix(.79 0 0 -.8 -335.4 1117.43)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#510000" />
        <stop offset={0.3} stopColor="#8a0000" />
        <stop offset={1} stopColor="#a00" />
      </linearGradient>
      <linearGradient
        id="Nicaragua_svg__linear-gradient-11"
        x1={-6092.94}
        x2={-6077.2}
        y1={3053.01}
        y2={3094.68}
        gradientTransform="matrix(.11 0 0 -.11 1327.68 693.79)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#ff2a2a" />
        <stop offset={1} stopColor="red" />
      </linearGradient>
      <style>
        {
          ".Nicaragua_svg__cls-2{fill:#fff}.Nicaragua_svg__cls-3{fill:#c8a400}.Nicaragua_svg__cls-5{fill:red}.Nicaragua_svg__cls-15{fill:#97c924}.Nicaragua_svg__cls-16{fill:#ede71f}.Nicaragua_svg__cls-17{fill:#c6cb24}.Nicaragua_svg__cls-18{fill:#9ecb34}.Nicaragua_svg__cls-22{fill:#93bc30}"
        }
      </style>
    </defs>
    <g id="Nicaragua_svg__Nicaragua">
      <path
        id="Nicaragua_svg__rect4"
        d="M.62.79h1280v719.26H.62z"
        style={{
          fill: "#0067c6",
        }}
      />
      <path
        id="Nicaragua_svg__rect6"
        d="M.62 240.54h1280v239.75H.62z"
        className="Nicaragua_svg__cls-2"
      />
      <g id="Nicaragua_svg__g3561-4">
        <g id="Nicaragua_svg__g6036-1">
          <g id="Nicaragua_svg__g3560-1">
            <g id="Nicaragua_svg__g5083-3">
              <path
                id="Nicaragua_svg__rect5026-8"
                d="m542.02 382.39-1.74.46 1.92 7.31 1.74-.46z"
                className="Nicaragua_svg__cls-3"
              />
              <path
                id="Nicaragua_svg__rect5081-7"
                d="m739.25 382.4 1.74.45-1.92 7.31-1.74-.46z"
                className="Nicaragua_svg__cls-3"
              />
            </g>
            <g id="Nicaragua_svg__g5894-4">
              <g id="Nicaragua_svg__g3221-1-2">
                <g id="Nicaragua_svg__g3223-7-7">
                  <path
                    id="Nicaragua_svg__path3225-4-7"
                    d="m626.26 455.27-7.84 11 2 .29 2.42-3.41 6.47.94 1.35 4 2 .29-4.4-12.76-2-.28Zm.73 2 1.71 5-4.76-.69Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <path
                id="Nicaragua_svg__path4160-4-5"
                d="m719.73 414.66 10.06 6.53 5.28-8.14-1.43-.93-4.22 6.51-.11.17-.13-.09-8.5-5.51Z"
                className="Nicaragua_svg__cls-3"
              />
              <path
                id="Nicaragua_svg__path4156-0"
                d="m565.69 420.47-8.54 8 1.14 1.22 7.2-6.73-3.78 10.39 1.31 1.4 10.32-3.13-7.07 6.61 1.14 1.22 8.55-8-1.74-1.85-10.49 3.13 3.93-10.15Z"
                className="Nicaragua_svg__cls-3"
              />
              <g id="Nicaragua_svg__g4169-6-9">
                <g id="Nicaragua_svg__g4171-1-0">
                  <path
                    id="Nicaragua_svg__path4173-4-0"
                    d="m560.56 413.15-13.4 1.54 1.12 1.67 4.15-.49 3.65 5.43-2 3.66 1.12 1.67 6.51-11.82-1.12-1.67Zm-1 1.89-2.56 4.61-2.69-4Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <g id="Nicaragua_svg__g3757-6">
                <g id="Nicaragua_svg__g3759-3">
                  <path
                    id="Nicaragua_svg__path3761-7"
                    d="m578.13 433.17-7.21 9.57 9.32 7 1-1.36-7.77-5.85-.16-.12.09-.12 2-2.67.09-.12.16.12 7 5.26 1-1.36-7-5.26-.16-.12.09-.12 1.77-2.34.09-.12.15.12 7.48 5.63 1-1.37Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <path
                id="Nicaragua_svg__path3799-5"
                d="m603.4 448.83-4.53 11.1 1.67.68 4.53-11.1Z"
                className="Nicaragua_svg__cls-3"
              />
              <g id="Nicaragua_svg__g3801-4">
                <g id="Nicaragua_svg__g3803-2">
                  <path
                    id="Nicaragua_svg__path3805-0"
                    d="M614.21 452.57a10 10 0 0 0-3.84-.55 5.73 5.73 0 0 0-3.17 1.1 5.3 5.3 0 0 0-1.89 2.71 6 6 0 0 0-.19 3.23 5.33 5.33 0 0 0 1.59 2.85 9.6 9.6 0 0 0 3.7 2 8.15 8.15 0 0 0 4.24.38 5.14 5.14 0 0 0 3-1.88l-1.56-.86c-1.57 1.87-3.44 1.41-5.39.78-3-1-4.59-3.13-3.72-6 1.08-3.07 4-3.13 6.64-2.32 1.83.61 3.4 1.4 3.63 3.21l1.72.26a4.8 4.8 0 0 0-1.32-2.9 7.94 7.94 0 0 0-3.48-2.07Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <g id="Nicaragua_svg__g3877-0">
                <g id="Nicaragua_svg__g3879-1">
                  <path
                    id="Nicaragua_svg__path3881-4"
                    d="M654.37 455.35a10.1 10.1 0 0 0-3.62 1.4 5.8 5.8 0 0 0-2.24 2.52 5.4 5.4 0 0 0-.32 3.28 6.3 6.3 0 0 0 1.42 2.92 5.4 5.4 0 0 0 2.79 1.7 9.8 9.8 0 0 0 4.21 0 8.1 8.1 0 0 0 3.88-1.76 5.1 5.1 0 0 0 1.73-3.12h-1.78c-.45 2.39-2.3 2.91-4.31 3.32-3.12.56-5.54-.49-6.16-3.38-.57-3.21 2-4.7 4.65-5.28 1.9-.36 3.65-.44 4.73 1l1.63-.61a4.76 4.76 0 0 0-2.56-1.88 8.1 8.1 0 0 0-4-.11Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <g id="Nicaragua_svg__g3915-2">
                <g id="Nicaragua_svg__g3917-6">
                  <path
                    id="Nicaragua_svg__path3919-6"
                    d="m662.37 453.93 3.41 11.49 11.22-3.31-.49-1.64-9.32 2.77-.19.06-.05-.15-.95-3.21v-.14l.19-.06 8.38-2.49-.48-1.62-8.38 2.49-.19.05-.05-.14-.83-2.81v-.14l.19-.06 9-2.66-.49-1.64Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <path
                id="Nicaragua_svg__path3953-0"
                d="m675.34 449.86 5 10.88 1.5-.7-4-8.62-.2-.45.5.21 11.42 5.29 2-.91-5-10.88-1.51.69 4 8.63.2.44-.49-.22L677.3 449Z"
                className="Nicaragua_svg__cls-3"
              />
              <path
                id="Nicaragua_svg__path4168-1"
                d="m688.5 443.67.94 1.43 4.28-2.82.17-.1.08.12 5.57 8.46 1.45-1-5.57-8.46-.08-.12.17-.11 4.3-2.83-.94-1.43Z"
                className="Nicaragua_svg__cls-3"
              />
              <g id="Nicaragua_svg__g4209-5-6">
                <g id="Nicaragua_svg__g4211-4-4">
                  <path
                    id="Nicaragua_svg__path4213-3-0"
                    d="m714.51 421.45 5.36 12.38 1.28-1.55-1.67-3.84 4.14-5.06 4.09.88 1.29-1.56-13.19-2.8-1.28 1.55Zm2.1.42 5.16 1.11-3 3.72Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <path
                id="Nicaragua_svg__path4162-1-8"
                d="m589.86 441.75-5.64 10.58 1.54.82 2.15-4 .09-.15.17.09 4.17 2.23.77.39c.15.73.91 4.46 1.24 6l2 1-1.35-6.3a3.43 3.43 0 0 0 4.34-1.75v-.08l.06-.1a2.74 2.74 0 0 0 .27-1.87 3.3 3.3 0 0 0-1-1.78A12.1 12.1 0 0 0 596 445l-.43-.22-5.72-3.06Zm.74 2.33.17.1 4.16 2.22c1.69.9 3.47 2.12 2.67 3.61s-3.1.52-4.44-.19l-4.2-2.24-.17-.09.07-.14 1.67-3.14z"
                className="Nicaragua_svg__cls-3"
              />
              <path
                id="Nicaragua_svg__path5862-3"
                d="m700.56 435.41 8.13 8.82 1.28-1.18-3.1-3.35-.1-.11.14-.14 3.48-3.2.62-.59 6.1.81 1.64-1.51-6.45-.85a3.43 3.43 0 0 0-.22-4.67l-.06-.06-.08-.09a2.8 2.8 0 0 0-1.68-.87 3.3 3.3 0 0 0-2 .34 12.3 12.3 0 0 0-2.58 1.94l-.36.33-4.77 4.39Zm2.45.07.14-.13 3.47-3.19c1.41-1.3 3.15-2.57 4.29-1.33s-.53 3.1-1.64 4.13l-3.5 3.23-.15.13-.1-.11-2.41-2.62Z"
                className="Nicaragua_svg__cls-3"
              />
            </g>
            <g id="Nicaragua_svg__g5728-8">
              <g id="Nicaragua_svg__g4374-1-3">
                <g id="Nicaragua_svg__g4376-9-7">
                  <path
                    id="Nicaragua_svg__path4378-8-1"
                    d="m599.63 260.65-1.26 13.43 1.87-.75.38-4.17 6.06-2.45 3.16 2.74 1.87-.75-10.22-8.81-1.87.76Zm1.64 1.37 4 3.45-4.46 1.8Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <path
                id="Nicaragua_svg__path3540-4"
                d="m690 264.44-5.44 10.68-1.56-.82 5.45-10.68Z"
                className="Nicaragua_svg__cls-3"
              />
              <path
                id="Nicaragua_svg__path4040-9"
                d="M534.28 341.24 546 344l2.65-11.36-1.66-.39-2.21 9.47v.19h-.15l-3.26-.76h-.15l.05-.19 2-8.51-1.65-.39-2 8.52v.19h-.15l-2.85-.67h-.14v-.2l2.13-9.11-1.67-.39Z"
                className="Nicaragua_svg__cls-3"
              />
              <path
                id="Nicaragua_svg__path4162-9"
                d="m538.49 325.57 11.32 3.94.58-1.66-4.32-1.5-.14-.05.07-.18 1.36-3.92c1.23-3.53 1-5.8-1.73-6.79a2.84 2.84 0 0 0-1.68-.09 3.3 3.3 0 0 0-1.47.79 5.9 5.9 0 0 0-1.15 1.64 18 18 0 0 0-.9 2.25Zm2.19-1.1.06-.18 1.36-3.9c.63-1.81 1.56-3.75 3.15-3.2s1 3 .51 4.43l-1.38 3.94-.06.18-.14-.05-3.36-1.17Z"
                className="Nicaragua_svg__cls-3"
              />
              <path
                id="Nicaragua_svg__path4002-2"
                d="m544.74 311.07 5.9 3.45a6 6 0 0 0 2.87 1 3.73 3.73 0 0 0 2.39-.88 9.7 9.7 0 0 0 2.29-2.79 9.5 9.5 0 0 0 1.3-3.37 3.64 3.64 0 0 0-.4-2.51 6.1 6.1 0 0 0-2.25-2l-5.9-3.45-.88 1.5 5.76 3.37c2.58 1.51 2.3 3.32.93 5.64-1.35 2.33-2.79 3.46-5.37 1.95l-5.76-3.37-.88 1.51Z"
                className="Nicaragua_svg__cls-3"
              />
              <g id="Nicaragua_svg__g4074-7-5">
                <g id="Nicaragua_svg__g4076-4-5">
                  <path
                    id="Nicaragua_svg__path4078-0-3"
                    d="m553.38 297 9.52 7.28 3.62-4.74c1.59-1.86 3.37-4.78.73-6.79a2.71 2.71 0 0 0-3.64-.13 2.17 2.17 0 0 0-.91-2.38 3.2 3.2 0 0 0-1.83-.64 3.5 3.5 0 0 0-1.88.66 9.5 9.5 0 0 0-2 2.07Zm2.41-.36.12-.16 2.45-3.2c.81-1.05 2-2.56 3.26-1.63s.09 2.5-.73 3.57l-2.45 3.2-.12.16-.12-.1-2.29-1.75Zm3.88 3 .12-.16 2.45-3.2c1.69-2.21 2.82-2.89 3.91-2.06s.7 2.14-1 4.31l-2.45 3.2-.11.16-.12-.09-2.71-2.07Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <path
                id="Nicaragua_svg__path4158-7"
                d="m574.73 275 7.3 9.5 1.43-1.1-7.31-9.5Z"
                className="Nicaragua_svg__cls-3"
              />
              <g id="Nicaragua_svg__g4112-2">
                <g id="Nicaragua_svg__g4114-2">
                  <path
                    id="Nicaragua_svg__path4116-8"
                    d="M585.46 267.72a10 10 0 0 0-2.87 2.6 5.8 5.8 0 0 0-1.19 3.15 5.38 5.38 0 0 0 .88 3.18 6.07 6.07 0 0 0 2.37 2.21 5.32 5.32 0 0 0 3.21.59 9.8 9.8 0 0 0 3.92-1.54 8.15 8.15 0 0 0 3-3 5.14 5.14 0 0 0 .5-3.53l-1.66.65c.44 2.39-1.11 3.54-2.84 4.64-2.7 1.65-5.34 1.53-7-.95-1.68-2.79.16-5.09 2.46-6.59 1.64-1 3.25-1.72 4.78-.74l1.3-1.16a4.8 4.8 0 0 0-3.07-.83 8 8 0 0 0-3.82 1.35Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <path
                id="Nicaragua_svg__path4150-6"
                d="m625.9 253.24.75 12 5.62-.35a14 14 0 0 0 2.53-.37 6.8 6.8 0 0 0 1.83-.71 5.2 5.2 0 0 0 1.35-1.16 5.4 5.4 0 0 0 1-1.81 6.4 6.4 0 0 0 .27-2.46 6.2 6.2 0 0 0-.8-2.82 5 5 0 0 0-2-1.92 6 6 0 0 0-2.33-.7 17.5 17.5 0 0 0-2.84 0l-5.36.34Zm1.85 1.59h.2l3.38-.22a10.6 10.6 0 0 1 2.85.09 4.27 4.27 0 0 1 3.22 3.74 4 4 0 0 1-2.93 4.34 20 20 0 0 1-2.55.39l-3.44.22h-.2v-.15l-.51-8.26Z"
                className="Nicaragua_svg__cls-3"
              />
              <g id="Nicaragua_svg__g4036-2">
                <g id="Nicaragua_svg__g4038-6">
                  <path
                    id="Nicaragua_svg__path4040-2-5"
                    d="m642.61 252.53-.68 12 11.64.66.1-1.7-9.71-.55h-.2v-.15l.19-3.34v-.15h.2l8.73.5.1-1.69-8.73-.5h-.2v-.15l.16-2.93v-.14h.2l9.34.53.1-1.71Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <path
                id="Nicaragua_svg__path4164-2"
                d="m673.91 257.52-4.33 11.18 1.54.6 3.43-8.86.18-.46.19.51 4.14 11.89 2 .78 4.35-11.16-1.54-.6-3.44 8.86-.18.45-.18-.5-4.15-11.89Z"
                className="Nicaragua_svg__cls-3"
              />
              <g id="Nicaragua_svg__g3542-0">
                <g id="Nicaragua_svg__g3544-0">
                  <path
                    id="Nicaragua_svg__path3546-3"
                    d="M699.06 269.74a10.2 10.2 0 0 0-3.57-1.53 5.8 5.8 0 0 0-3.35.24 5.37 5.37 0 0 0-2.53 2.12 6.1 6.1 0 0 0-1 3.08 5.36 5.36 0 0 0 .8 3.16 9.7 9.7 0 0 0 3 2.92 8.1 8.1 0 0 0 4 1.46 5.16 5.16 0 0 0 3.42-1l-1.28-1.24c-2 1.4-3.69.47-5.41-.64-2.62-1.78-3.62-4.22-2-6.72 1.83-2.69 4.69-2 7-.52 1.61 1.06 2.92 2.23 2.67 4l1.59.7a4.74 4.74 0 0 0-.51-3.13 8.1 8.1 0 0 0-2.82-2.91Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <g id="Nicaragua_svg__g4335-4-2">
                <g id="Nicaragua_svg__g4337-4-9">
                  <path
                    id="Nicaragua_svg__path4340-6-4"
                    d="m710.47 278.35-12.53 5 1.52 1.31 3.88-1.56 4.93 4.29-1 4.06 1.52 1.32 3.21-13.1-1.52-1.32Zm-.48 2.08-1.26 5.12-3.63-3.15Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <g id="Nicaragua_svg__g4296-5-9">
                <g id="Nicaragua_svg__g4298-9-3">
                  <path
                    id="Nicaragua_svg__path4300-8-9"
                    d="m733.55 305.75-13.48.62 1 1.75 4.18-.21 3.26 5.67-2.28 3.51 1 1.74 7.3-11.34-1-1.75Zm-1.14 1.82-2.86 4.43-2.4-4.17Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <path
                id="Nicaragua_svg__path4152-4"
                d="M741.24 321.62a11.5 11.5 0 0 0-2.08-3.68 5.63 5.63 0 0 0-3-1.85 5.57 5.57 0 0 0-3.31.16 5.23 5.23 0 0 0-2.59 2 5.9 5.9 0 0 0-1 3.39 11.6 11.6 0 0 0 .74 4.23 12.4 12.4 0 0 0 1.57 3 12 12 0 0 0 .94 1.18l-.89.32.57 1.59 1.69-.6 3.93-1.41-2.19-6.07-1.29.47 1.53 4.28.07.19-.14.05-1.7.61h-.06l-.07-.05a10.05 10.05 0 0 1-2.64-4.2c-1-3.1-1.06-6.1 2.24-7.32s5.31 1.54 6.33 4.21c.67 1.91 1 3.85-.42 5.24l.81 1.35a4.56 4.56 0 0 0 1.28-1.64 5.3 5.3 0 0 0 .32-2.4 10.6 10.6 0 0 0-.66-3Z"
                className="Nicaragua_svg__cls-3"
              />
              <path
                id="Nicaragua_svg__path3670-4"
                d="m744.68 331-6.7 1.31a6 6 0 0 0-2.8 1.16 3.72 3.72 0 0 0-1.21 2.24 9.6 9.6 0 0 0 .12 3.61 9.7 9.7 0 0 0 1.25 3.39 3.7 3.7 0 0 0 2 1.63 6.2 6.2 0 0 0 3 0l6.7-1.31-.33-1.71-6.54 1.27c-2.94.58-3.93-1-4.43-3.61-.52-2.64-.18-4.44 2.75-5l6.54-1.28-.33-1.71Z"
                className="Nicaragua_svg__cls-3"
              />
              <g id="Nicaragua_svg__g4252-6-1">
                <g id="Nicaragua_svg__g4256-0-6">
                  <path
                    id="Nicaragua_svg__path4258-1-1"
                    d="M748.36 351.39 736 346.08l.15 2 3.85 1.63.47 6.52-3.57 2.17.14 2 11.51-7-.14-2Zm-1.81 1.14-4.55 2.73-.35-4.8Z"
                    className="Nicaragua_svg__cls-3"
                  />
                </g>
              </g>
              <path
                id="Nicaragua_svg__path4485-1"
                d="m564.17 284.24 8.23 8.76 7.06-6.66-1.17-1.24-5.64 5.33-.15.14-.1-.11-7-7.37Z"
                className="Nicaragua_svg__cls-3"
              />
              <path
                id="Nicaragua_svg__path5882-4"
                d="m532.73 359.61 12 .8.12-1.74-4.56-.3h-.15v-.19l.31-4.72v-.85l5-3.62.14-2.22-5.26 3.82a3.42 3.42 0 0 0-3.38-3.23h-.2a2.72 2.72 0 0 0-1.81.52 3.27 3.27 0 0 0-1.22 1.62 12.2 12.2 0 0 0-.54 3.19v.48l-.43 6.47Zm1.82-1.63v-.19l.32-4.71c.12-1.91.51-4 2.19-3.92s1.75 2.62 1.66 4.14l-.32 4.74v.2h-.16l-3.54-.24Z"
                className="Nicaragua_svg__cls-3"
              />
              <path
                id="Nicaragua_svg__path5884-6"
                d="m719.52 286.68-9.25 7.62 1.12 1.35 3.52-2.9.12-.1.12.15 3 3.65c.19.23.37.44.56.65-.14.74-.86 4.47-1.15 6l1.41 1.71 1.21-6.38a3.43 3.43 0 0 0 4.67 0l.07-.06.09-.07a2.8 2.8 0 0 0 1-1.63 3.28 3.28 0 0 0-.22-2 12.5 12.5 0 0 0-1.8-2.69l-.31-.37-4.13-5Zm-.2 2.43.12.15 3 3.64c1.22 1.48 2.39 3.29 1.1 4.36s-3.07-.71-4-1.87l-3-3.67-.13-.15.12-.1 2.75-2.26.11-.1Z"
                className="Nicaragua_svg__cls-3"
              />
            </g>
          </g>
        </g>
        <path
          id="Nicaragua_svg__rect4263-2"
          d="m640.62 272.2-37.74 65.37-18.48 32h112.44L679.2 339Z"
          className="Nicaragua_svg__cls-2"
        />
        <g id="Nicaragua_svg__g4141-9">
          <path
            id="Nicaragua_svg__path4332-1"
            d="m640.62 272.2-2.83 4.89 2.83 65.9 2.82-65.9Zm0 70.79 9.93-53.59-4-6.92Zm0 0 15-44.76-2.92-5.07Zm0 0 19-37.9-2.31-4Zm0 0 22.26-32.23-1.88-3.34Zm0 0 25.13-27.25-1.7-3Zm0 0 27.76-22.7-1.58-2.73Zm0 0 30.26-18.36-1.51-2.63Zm0 0 32.75-14.06-1.52-2.62Zm0 0 35.32-9.6-1.58-2.74Zm0 0 38.09-4.81-1.72-3Zm0 0 41.2.57-2-3.37Zm0 0 44.88 6.95-2.33-4Zm0 0 49.48 14.93-2.94-5.1Zm0 0 55.7 25.7-4-7Zm0 0L682 369.58h8.91Zm0 0 30.89 26.59h5.9Zm0 0L664 369.58h4.32Zm0 0 17.51 26.59h3.42Zm0 0 12.63 26.59h2.88Zm0 0 8.38 26.59h2.54Zm0 0 4.45 26.59h2.35Zm0 0 .72 26.59h2.26Zm0 0-3 26.59h2.26Zm0 0-6.8 26.59h2.35Zm0 0-10.9 26.59h2.54Zm0 0-15.51 26.59H628Zm0 0-20.94 26.59h3.43Zm0 0-27.7 26.59h4.32Zm0 0-36.79 26.59h5.89Zm0 0-50.25 26.59h8.9Zm0 0-51.68 18.72-4 7Zm0 0-46.54 9.83-3 5.1Zm0 0-42.55 2.93-2.33 4Zm0 0-39.25-2.8-2 3.37Zm0 0-36.37-7.78-1.37 2.36-.35.61Zm0 0-33.74-12.34-1.58 2.74Zm0 0-31.23-16.68-1.52 2.62Zm0 0-28.75-21-1.52 2.63Zm0 0-26.18-25.43-1.58 2.73Zm0 0-23.43-30.21-1.71 3Zm0 0-20.33-35.57-1.93 3.35Zm0 0-16.68-41.91-2.31 4Zm0 0-12.1-49.83-2.93 5.07Zm0 0-5.94-60.52-4 6.94Z"
            style={{
              fill: "#17c0eb",
              stroke: "#17c0eb",
              strokeWidth: "1.14px",
              isolation: "isolate",
              opacity: 0.62,
            }}
          />
        </g>
        <g id="Nicaragua_svg__g4517-5">
          <path
            id="Nicaragua_svg__path4467-0"
            d="M640.62 319.49a53 53 0 0 0-34.72 12.89l-17.57 30.44a53.6 53.6 0 0 0-.92 9.88v.88h6.71v-.88a46.5 46.5 0 1 1 93 0v.88h6.71v-.88a53.5 53.5 0 0 0-.92-9.87l-17.58-30.46a53 53 0 0 0-34.71-12.88"
            className="Nicaragua_svg__cls-5"
          />
          <path
            id="Nicaragua_svg__path4464-3"
            d="M640.62 320.45a52 52 0 0 0-36.3 14.67l-14.42 25a52.3 52.3 0 0 0-1.54 12.6v.88h5.76v-.88a46.5 46.5 0 1 1 93 0v.88h5.75v-.88a52.8 52.8 0 0 0-1.53-12.6l-14.43-25a52 52 0 0 0-36.29-14.67"
            style={{
              fill: "#f60",
            }}
          />
          <path
            id="Nicaragua_svg__path4459-6"
            d="M640.62 321.41a51.15 51.15 0 0 0-38.3 17.17l-10.44 18.08a51.3 51.3 0 0 0-2.56 16v.88h4.8v-.88a46.5 46.5 0 1 1 93 0v.88h4.79v-.88a51.2 51.2 0 0 0-2.56-16l-10.44-18.09a51.17 51.17 0 0 0-38.29-17.16"
            style={{
              fill: "#ff0",
            }}
          />
          <path
            id="Nicaragua_svg__path4451-4"
            d="M640.62 322.37a50.27 50.27 0 0 0-41.84 22.35l-3.37 5.84a50.1 50.1 0 0 0-5.13 22.14v.88h3.84v-.88a46.5 46.5 0 1 1 93 0v.88h3.83v-.88a50.3 50.3 0 0 0-5.1-22.11l-3.41-5.91a50.29 50.29 0 0 0-41.82-22.31"
            style={{
              fill: "#0f0",
            }}
          />
          <path
            id="Nicaragua_svg__path4366-9"
            d="M640.62 323.33a49.37 49.37 0 0 0-49.38 49.37v.88h2.88v-.88a46.5 46.5 0 1 1 93 0v.88H690v-.88a49.37 49.37 0 0 0-49.38-49.37"
            style={{
              fill: "#0cf",
            }}
          />
          <path
            id="Nicaragua_svg__path4495-2"
            d="M640.62 324.28a48.42 48.42 0 0 0-48.42 48.42v.88h1.92v-.88a46.5 46.5 0 1 1 93 0v.88H689v-.88a48.41 48.41 0 0 0-48.41-48.42Z"
            style={{
              fill: "#00f",
            }}
          />
          <path
            id="Nicaragua_svg__path4436-9"
            d="M640.62 325.24a47.46 47.46 0 0 0-47.46 47.46v.88h1v-.88a46.5 46.5 0 1 1 93 0v.88h.95v-.88a47.45 47.45 0 0 0-47.45-47.46Z"
            style={{
              fill: "purple",
            }}
          />
        </g>
        <g id="Nicaragua_svg__g5175">
          <path
            id="Nicaragua_svg__rect5173"
            d="m584.4 369.58-11.94 20.66h136.31l-11.93-20.66Z"
            className="Nicaragua_svg__cls-2"
          />
        </g>
        <g id="Nicaragua_svg__g5189">
          <g id="Nicaragua_svg__g4092">
            <path
              id="Nicaragua_svg__rect4181"
              d="m584.55 369.36-.15.25h112.43l-.14-.25Zm-.26.45-.16.26h113l-.15-.26Zm-.24.41-.25.43h113.63l-.24-.43Zm-.38.66-.3.52h114.5l-.3-.52Zm-.48.83-.3.52h115.46l-.3-.52Zm-.48.83-.3.52h116.41l-.3-.52Zm-.48.83-.3.52H699.3l-.3-.52Zm-.51.89-.37.64h118.53l-.36-.64Z"
              style={{
                fill: "url(#Nicaragua_svg__linear-gradient)",
              }}
            />
            <path
              id="Nicaragua_svg__path5179"
              d="M589.5 375.15c4.13.79 4.53 0 4.53 0Zm97.7 0s.4.79 4.53 0Zm-105.54.18h-.57l-.38.67c.64-.06 1.28-.11 1.94-.13 4 .1 7.54 1 11.74 1h5.42c4.2 0 7.78-.92 11.73-1 4 .1 7.56 1 11.75 1h5.43c4.19 0 7.76-.92 11.71-1 3.94.1 7.51 1 11.71 1h5.44c4.2 0 7.78-.92 11.74-1 3.95.1 7.52 1 11.72 1h5.43c4.2 0 7.76-.92 11.71-1 .8 0 1.59.1 2.37.17l-.42-.73h-4.33c-4.2 0-7.76.9-11.71 1-3.95-.09-7.53-1-11.73-1h-5.42c-4.2 0-7.79.9-11.74 1-3.94-.09-7.53-1-11.72-1h-5.45c-4.2 0-7.77.9-11.71 1-4-.09-7.52-1-11.71-1h-5.43c-4.19 0-7.78.9-11.73 1-4-.09-7.53-1-11.72-1h-4.12Zm-1.34 1.34-.42.74c.9-.09 1.82-.15 2.75-.18 4 .1 7.54 1 11.74 1h5.42c4.2 0 7.78-.92 11.73-1 4 .1 7.56 1 11.75 1h5.43c4.2 0 7.76-.92 11.71-1 3.94.1 7.51 1 11.71 1h5.44c4.2 0 7.78-.92 11.74-1 3.95.1 7.52 1 11.72 1h5.43c4.2 0 7.76-.92 11.71-1 1.08 0 2.14.13 3.19.24l-.45-.78h-5.07c-4.2 0-7.76.9-11.71 1-3.95-.09-7.53-1-11.73-1h-5.42c-4.2 0-7.79.9-11.74 1-3.94-.09-7.53-1-11.72-1h-5.45c-4.2 0-7.77.9-11.71 1-4-.09-7.52-1-11.71-1h-5.43c-4.19 0-7.78.9-11.73 1-4-.09-7.53-1-11.72-1h-5.45Zm0 1.33h-.78l-.48.85c1.17-.14 2.37-.26 3.59-.29 4 .1 7.54 1 11.74 1h5.42c4.2 0 7.78-.9 11.73-1 4 .1 7.56 1 11.75 1h5.43c4.2 0 7.76-.9 11.71-1 3.94.1 7.51 1 11.71 1h5.44c4.2 0 7.78-.9 11.74-1 3.95.1 7.52 1 11.72 1h5.43c4.2 0 7.76-.9 11.71-1 1.37 0 2.7.17 4 .32l-.51-.88h-5.84c-4.2 0-7.76.9-11.71 1-3.95-.1-7.53-1-11.73-1h-5.42c-4.2 0-7.79.9-11.74 1-3.94-.1-7.53-1-11.72-1h-5.45c-4.2 0-7.77.9-11.71 1-4-.1-7.52-1-11.71-1h-5.43c-4.19 0-7.77.9-11.73 1-4-.1-7.53-1-11.73-1h-5.45Zm0 1.34h-1.56l-.54.93c1.46-.17 2.92-.34 4.43-.38 4 .09 7.54 1 11.74 1h5.42c4.2 0 7.78-.9 11.73-1 4 .09 7.56 1 11.75 1h5.43c4.2 0 7.76-.9 11.71-1 3.94.09 7.51 1 11.71 1h5.44c4.2 0 7.78-.9 11.74-1 3.95.09 7.52 1 11.72 1h5.43c4.2 0 7.76-.9 11.71-1 1.65 0 3.25.23 4.85.42l-.56-1h-6.62c-4.24 0-7.84.92-11.83 1-3.91-.11-7.45-1-11.61-1h-5.42c-4.2 0-7.79.9-11.74 1-3.94-.09-7.53-1-11.72-1h-5.45c-4.2 0-7.77.9-11.71 1-4-.09-7.52-1-11.71-1h-5.43c-4.15 0-7.7.88-11.6 1-4-.07-7.62-1-11.86-1h-5.45Zm0 1.34c-.81 0-1.59 0-2.36.1l-.55 1c1.73-.21 3.45-.42 5.24-.46 4 .09 7.54 1 11.74 1h5.42c4.2 0 7.78-.9 11.73-1 4 .09 7.56 1 11.75 1h5.43c4.2 0 7.76-.9 11.71-1 3.94.09 7.51 1 11.71 1h5.44c4.2 0 7.78-.9 11.74-1 3.95.09 7.52 1 11.72 1h5.43c4.2 0 7.76-.9 11.71-1a56 56 0 0 1 5.69.52l-.6-1c-.65 0-1.3-.08-2-.08h-5.45c-4.2 0-7.76.89-11.71 1-3.95-.09-7.53-1-11.73-1h-5.42c-4.2 0-7.79.9-11.74 1-3.94-.09-7.53-1-11.72-1h-5.45c-4.2 0-7.77.9-11.71 1-4-.09-7.52-1-11.71-1h-5.43c-4.2 0-7.78.9-11.73 1-4-.1-7.53-1-11.73-1h-5.45Zm0 1.34c-1.09 0-2.14.07-3.17.16l-.58 1a61 61 0 0 1 6.08-.56c4 .09 7.54 1 11.74 1h5.42c4.2 0 7.78-.9 11.73-1 4 .09 7.56 1 11.75 1h5.43c4.2 0 7.76-.9 11.71-1 3.94.09 7.51 1 11.71 1h5.44c4.2 0 7.78-.9 11.74-1 3.95.09 7.52 1 11.72 1h5.43c4.2 0 7.76-.9 11.71-1 2.23.05 4.34.36 6.52.62l-.64-1.09c-.9-.08-1.81-.12-2.76-.12h-5.45c-4.2 0-7.76.9-11.71 1-3.95-.09-7.53-1-11.73-1h-5.42c-4.2 0-7.79.9-11.74 1-3.94-.09-7.53-1-11.72-1h-5.45c-4.2 0-7.77.9-11.71 1-4-.09-7.52-1-11.71-1h-5.43c-4.2 0-7.78.9-11.73 1-4-.09-7.53-1-11.73-1h-5.45Zm0 1.33a37 37 0 0 0-4 .25l-.59 1c2.31-.27 4.55-.61 6.91-.67 4 .1 7.54 1 11.74 1h5.42c4.2 0 7.78-.9 11.73-1 4 .1 7.56 1 11.75 1h5.43c4.2 0 7.76-.9 11.71-1 3.94.1 7.51 1 11.71 1h5.44c4.2 0 7.78-.9 11.74-1 3.95.1 7.52 1 11.72 1h5.43c4.2 0 7.76-.9 11.71-1 2.51.06 4.88.46 7.35.73l-.65-1.12c-1.16-.11-2.34-.2-3.58-.2h-5.45c-4.19 0-7.76.9-11.71 1-3.95-.1-7.53-1-11.72-1h-5.43c-4.2 0-7.79.9-11.74 1-3.94-.1-7.53-1-11.72-1h-5.45c-4.2 0-7.77.9-11.71 1-4-.1-7.52-1-11.71-1h-5.43c-4.19 0-7.78.9-11.73 1-4-.1-7.53-1-11.72-1h-5.46Zm0 1.34a41 41 0 0 0-4.81.32l-.59 1c2.6-.27 5.08-.7 7.73-.76 4 .09 7.54 1 11.74 1h5.42c4.2 0 7.78-.9 11.73-1 4 .09 7.56 1 11.75 1h5.43c4.19 0 7.76-.9 11.71-1 3.94.09 7.51 1 11.71 1h5.44c4.2 0 7.78-.9 11.74-1 3.95.09 7.52 1 11.72 1h5.43c4.2 0 7.76-.9 11.71-1 2.79.07 5.39.54 8.16.81l-.64-1.06a39 39 0 0 0-4.4-.28h-5.45c-4.2 0-7.76.9-11.71 1-3.95-.09-7.53-1-11.73-1h-5.42c-4.2 0-7.79.9-11.74 1-3.94-.09-7.53-1-11.72-1h-5.45c-4.2 0-7.77.9-11.71 1-4-.09-7.52-1-11.71-1h-5.43c-4.19 0-7.78.9-11.73 1-4-.09-7.53-1-11.73-1h-5.45Zm0 1.34a46 46 0 0 0-5.64.42l-.58 1c2.91-.25 5.63-.77 8.55-.85 4 .1 7.54 1 11.74 1h5.42c4.2 0 7.78-.9 11.73-1 4 .1 7.56 1 11.75 1h5.43c4.2 0 7.76-.9 11.71-1 3.94.1 7.51 1 11.71 1h5.44c4.2 0 7.78-.9 11.74-1 3.95.1 7.52 1 11.72 1h5.43c4.2 0 7.76-.9 11.71-1 3.06.08 5.9.63 9 .87l-.62-1.07a44 44 0 0 0-5.23-.38h-5.45c-4.2 0-7.76.89-11.71 1-3.95-.1-7.53-1-11.73-1h-5.42c-4.2 0-7.79.89-11.74 1-3.94-.1-7.53-1-11.72-1h-5.45c-4.2 0-7.77.89-11.71 1-4-.1-7.52-1-11.71-1h-5.43c-4.19 0-7.78.89-11.73 1-4-.1-7.53-1-11.72-1h-5.46Z"
              style={{
                fill: "url(#Nicaragua_svg__linear-gradient-2)",
              }}
            />
          </g>
        </g>
        <path
          id="Nicaragua_svg__path4343"
          d="M677.34 356.87c-2.05 0-2.68 1-2.68 1-3.28 12.68-14.15 25.58-27.09 25.58h-9.69v12.91h73.74l-7.41-13.13c-11.64-1.74-21.15-13.64-24.18-25.36a3.08 3.08 0 0 0-2.69-1"
          style={{
            fill: "url(#Nicaragua_svg__linear-gradient-3)",
          }}
        />
        <path
          id="Nicaragua_svg__path4248"
          d="M677.34 357.38a3.43 3.43 0 0 0-1.85.42c-.32.2-.38.33-.38.35a40.3 40.3 0 0 1-10 17.63c-4.8 4.88-10.87 8.18-17.5 8.18h-9.2v11.9h73l-6.81-12.06c-5.62-.73-10.76-3.79-14.94-8a40.35 40.35 0 0 1-10-17.63s-.08-.13-.4-.33a3.4 3.4 0 0 0-1.84-.44Z"
          className="Nicaragua_svg__cls-15"
        />
        <g id="Nicaragua_svg__g4260">
          <g id="Nicaragua_svg__g4262">
            <path
              id="Nicaragua_svg__path4264"
              d="M677.33 357.38a4 4 0 0 1 .49 0v12.95c0 2.8-1 5.06-2.41 7.72-.66 1.86-1.18 1.15-2.82 3.42a30.2 30.2 0 0 1-6.16 1.46c-3 .48-9.73.9-13 .16a27.7 27.7 0 0 0 11.72-7.33q1.33-1.37 2.55-2.88a40.6 40.6 0 0 0 3.61-5.37c.42-.75.82-1.5 1.19-2.27.56-1.16 1.06-2.34 1.5-3.52.15-.4.29-.8.43-1.2.26-.8.5-1.59.71-2.39s.07-.15.38-.35a2.7 2.7 0 0 1 .69-.28 4.3 4.3 0 0 1 1.13-.14Z"
              className="Nicaragua_svg__cls-16"
            />
            <path
              id="Nicaragua_svg__path4266"
              d="M676.5 359.1c-.49 7.23-2.73 15.81-8 21.35-1.93 1.6-4.39 3.06-6.77 2.7 8.12-6.6 13.05-16.71 14.73-24Z"
              className="Nicaragua_svg__cls-17"
            />
          </g>
          <path
            id="Nicaragua_svg__path4268"
            d="M670 371.54c-1.2 3.26-5.74 8.09-10.6 12a29 29 0 0 1-3.36.05c2.96-.23 9.84-6.05 13.96-12.05"
            className="Nicaragua_svg__cls-18"
          />
        </g>
        <path
          id="Nicaragua_svg__path4339"
          d="M661.65 357.91c3.28 12.68 14.14 25.58 27.07 25.58h9.7v12.9h-78.91v-12.9h9.67c12.94 0 23.82-12.9 27.1-25.58 0 0 .64-1 2.68-1s2.69 1 2.69 1"
          style={{
            fill: "url(#Nicaragua_svg__linear-gradient-4)",
          }}
        />
        <path
          id="Nicaragua_svg__path4224"
          d="M659 357.38a3.43 3.43 0 0 1 1.85.44c.32.2.4.31.4.33a40.3 40.3 0 0 0 10 17.63c4.81 4.88 10.89 8.18 17.52 8.18h9.16v11.9H620V384h9.2c6.63 0 12.7-3.3 17.51-8.18a40.35 40.35 0 0 0 10-17.63s.07-.15.38-.35a3.46 3.46 0 0 1 1.85-.42Z"
          className="Nicaragua_svg__cls-15"
        />
        <g id="Nicaragua_svg__g4236">
          <g id="Nicaragua_svg__g4238">
            <path
              id="Nicaragua_svg__path4240"
              d="M659 357.38a4 4 0 0 1 .48 0v12.95c0 2.8-1 5.06-2.41 7.72-.66 1.86-1.18 1.15-2.82 3.42a30.2 30.2 0 0 1-6.16 1.46c-3 .48-9.73.9-13 .16a27.7 27.7 0 0 0 11.72-7.33 37 37 0 0 0 2.55-2.88 40.6 40.6 0 0 0 3.61-5.37c.42-.75.82-1.5 1.19-2.27.56-1.16 1.06-2.34 1.5-3.52.15-.4.29-.8.43-1.2.26-.8.5-1.59.71-2.39s.07-.15.38-.35a2.7 2.7 0 0 1 .69-.28 4.4 4.4 0 0 1 1.14-.14Z"
              className="Nicaragua_svg__cls-16"
            />
            <path
              id="Nicaragua_svg__path4242"
              d="M658.12 359.1c-.49 7.23-2.73 15.81-8 21.35-1.93 1.6-4.39 3.06-6.77 2.7 8.12-6.6 13.05-16.71 14.73-24Z"
              className="Nicaragua_svg__cls-17"
            />
          </g>
          <path
            id="Nicaragua_svg__path4244"
            d="M651.6 371.54c-1.2 3.26-5.74 8.09-10.6 12a29 29 0 0 1-3.36.05c2.96-.23 9.86-6.05 13.96-12.05"
            className="Nicaragua_svg__cls-18"
          />
        </g>
        <path
          id="Nicaragua_svg__path4335"
          d="M643.27 357.91c3.28 12.68 14.14 25.58 27.08 25.58H680v12.9h-78.87v-12.9h9.68c12.93 0 23.81-12.9 27.09-25.58 0 0 .64-1 2.69-1s2.69 1 2.69 1Z"
          style={{
            fill: "url(#Nicaragua_svg__linear-gradient-5)",
          }}
        />
        <path
          id="Nicaragua_svg__path4187"
          d="M640.59 357.38a3.4 3.4 0 0 1 1.84.44 1.3 1.3 0 0 1 .41.33 40.25 40.25 0 0 0 10 17.63c4.81 4.88 10.89 8.18 17.53 8.18h9.15v11.9h-77.88V384h9.2c6.63 0 12.7-3.3 17.51-8.18a40.35 40.35 0 0 0 10-17.63s.07-.15.38-.35a3.46 3.46 0 0 1 1.85-.42Z"
          className="Nicaragua_svg__cls-15"
        />
        <g id="Nicaragua_svg__g4201">
          <path
            id="Nicaragua_svg__path4203"
            d="m639.73 357.45-.29.07a2.6 2.6 0 0 0-.68.28c-.32.2-.38.33-.39.35-.21.8-.44 1.6-.71 2.39-.13.4-.28.8-.43 1.19-.44 1.19-.94 2.37-1.5 3.53-.37.77-.77 1.52-1.19 2.27a40.6 40.6 0 0 1-3.61 5.37 37 37 0 0 1-2.55 2.88 27.7 27.7 0 0 1-11.71 7.33c3.31.74 4.83-.07 7.85-.54a42.4 42.4 0 0 0 7.24-1.46c1.64-2.27 1.08-1.56 1.73-3.42 1.42-2.66 3.49-5.06 4-8 1.9-3.61 2.24-10.32 2.24-12.24"
            className="Nicaragua_svg__cls-16"
          />
          <path
            id="Nicaragua_svg__path4205"
            d="M639.75 359.1c-.5 7.23-2.73 15.81-8 21.35-1.92 1.6-4.39 3.06-6.77 2.7 8.12-6.6 13-16.71 14.74-24Z"
            className="Nicaragua_svg__cls-17"
          />
        </g>
        <path
          id="Nicaragua_svg__path4207"
          d="M633.22 371.54c-1.2 3.26-5.74 8.09-10.6 12a29 29 0 0 1-3.36.05c3-.27 9.86-6.09 14-12.09Z"
          className="Nicaragua_svg__cls-18"
        />
        <path
          id="Nicaragua_svg__path4545-6-5"
          d="M625 357.91c3.28 12.68 14.13 25.58 27.07 25.58h9.7v12.9h-78.9v-12.9h9.68c12.94 0 23.81-12.9 27.09-25.58 0 0 .64-1 2.69-1s2.69 1 2.69 1Z"
          style={{
            fill: "url(#Nicaragua_svg__linear-gradient-6)",
          }}
        />
        <path
          id="Nicaragua_svg__path4048"
          d="M622.21 357.38a3.43 3.43 0 0 0-1.85.44 1.15 1.15 0 0 0-.4.33 40.25 40.25 0 0 1-10 17.63c-4.82 4.88-10.9 8.19-17.53 8.19h-9.16v11.89h77.89l.24-11.86h-9.2c-6.64 0-12.94-3.31-17.75-8.19a40.15 40.15 0 0 1-10-17.63s-.07-.15-.39-.35a3.4 3.4 0 0 0-1.84-.42Z"
          className="Nicaragua_svg__cls-15"
        />
        <g id="Nicaragua_svg__g4152">
          <path
            id="Nicaragua_svg__path4154"
            d="M620.77 359.1c-.77 10.84-6.77 24.52-13.59 26.9a43 43 0 0 1-7.47 1.21c11.93-5.68 19-19 21.06-28.09Z"
            className="Nicaragua_svg__cls-22"
          />
        </g>
        <path
          id="Nicaragua_svg__path4545-6"
          d="M603.84 356.87c-2.05 0-2.7 1-2.7 1-3 11.69-14.17 26.76-25.77 28.55l-5.74 9.94h73.66v-12.88h-9.71c-12.93 0-23.79-12.9-27.07-25.58 0 0-.62-1.03-2.67-1.03"
          style={{
            fill: "url(#Nicaragua_svg__linear-gradient-7)",
          }}
        />
        <path
          id="Nicaragua_svg__path4119"
          d="M603.84 357.38a3.43 3.43 0 0 0-1.85.44 1.15 1.15 0 0 0-.4.33c-1.68 6.38-5.61 12.83-9.69 18s-11.67 10.32-16.85 10.85l-5.14 8.86h72.88V384h-9.2c-6.64 0-12.7-3.3-17.51-8.18a40.25 40.25 0 0 1-10-17.63s-.07-.15-.39-.35a3.4 3.4 0 0 0-1.85-.46"
          className="Nicaragua_svg__cls-15"
        />
        <path
          id="Nicaragua_svg__path4078"
          d="M602.4 359.1c-.74 10.84-6.78 24.52-13.59 26.88a43 43 0 0 1-7.47 1.21c11.93-5.68 19-19 21.06-28.09"
          className="Nicaragua_svg__cls-22"
        />
        <g id="Nicaragua_svg__g4900">
          <path
            id="Nicaragua_svg__path4902"
            d="M603.84 357.38a4 4 0 0 0-.49 0v12.95c0 2.8 1 5.06 2.41 7.72a6 6 0 0 0 .24.59c.5 1.3.86 1.75 2.74 3.18 6 4.54 13.39 5.22 17.75 4.84-1.36-1.08-2.82-2.06-4.11-3a30.5 30.5 0 0 0 5.41-.61 27.6 27.6 0 0 1-11.71-7.33c-.59-.6-1.14-1.23-1.69-1.87l-.7-1a40 40 0 0 1-3.77-5.41c-.43-.75-.83-1.5-1.2-2.27-.56-1.16-1.06-2.34-1.5-3.52q-.22-.6-.42-1.2c-.27-.8-.5-1.59-.71-2.39 0 0-.07-.15-.39-.35a2.7 2.7 0 0 0-.69-.28 4.3 4.3 0 0 0-1.13-.14Z"
            className="Nicaragua_svg__cls-16"
          />
        </g>
        <path
          id="Nicaragua_svg__path4054"
          d="M604.68 359.1c.49 7.23 2.73 15.81 8 21.35 1.93 1.6 4.39 3.06 6.77 2.7-8.16-6.6-13.09-16.72-14.77-24.05"
          className="Nicaragua_svg__cls-17"
        />
        <path
          id="Nicaragua_svg__path4104"
          d="M609.67 369.1c2.84 7 10 13.54 17.44 17.93a27 27 0 0 0 3-.07c-5.3-2.84-13.84-6.9-20.48-17.86Z"
          className="Nicaragua_svg__cls-18"
        />
        <g id="Nicaragua_svg__g3308-4">
          <path
            id="Nicaragua_svg__path3310-2"
            d="M641.76 357.52a2.6 2.6 0 0 1 .68.28c.32.2.38.33.39.35.21.8.44 1.6.71 2.39.13.4.28.8.43 1.19.44 1.19.93 2.37 1.49 3.53.38.77.78 1.52 1.2 2.27a40.6 40.6 0 0 0 3.61 5.37 37 37 0 0 0 2.55 2.88c3.37 3.41 7.35 6.53 11.71 7.8-8.68 0-12.45-.75-15.61-4.81s-4.32-5.84-5-8.32-2.35-7.85-2.16-12.93"
            className="Nicaragua_svg__cls-16"
          />
        </g>
        <path
          id="Nicaragua_svg__path4911"
          d="M582.52 390.37c-3.45 0-7.45.72-10.71 1l-7.52 13H717l-7.55-13.07c-3.12-.31-7-1-10.3-1h-3.99c-4.32 0-8 1.13-12.08 1.13s-7.76-1.13-12.08-1.13h-3.99c-4.32 0-8 1.13-12.08 1.13s-7.76-1.13-12.08-1.13h-4.06c-4.32 0-7.95 1.13-12.06 1.13s-7.74-1.13-12.05-1.13h-4c-4.32 0-8 1.13-12.07 1.13s-7.76-1.13-12.08-1.13h-3.08Z"
          className="Nicaragua_svg__cls-2"
        />
        <path
          id="Nicaragua_svg__path4909"
          d="M581.05 389.72a73 73 0 0 0-8.78.9l-.53.91h.06c4.15 0 7.65-1 11.55-1.15 3.9.11 7.44 1.15 11.59 1.15h2.47a2 2 0 0 0 .22 0 2 2 0 0 0 .25 0h2.43c4.15 0 7.69-1 11.59-1.15 3.9.11 7.47 1.15 11.61 1.15h2.45a2 2 0 0 0 .22 0 2 2 0 0 0 .23 0h2.46c4.15 0 7.67-1 11.57-1.15 3.9.11 7.42 1.15 11.57 1.15h2.48a2 2 0 0 0 .23 0 2 2 0 0 0 .25 0h2.44c4.15 0 7.69-1 11.59-1.15 3.9.11 7.44 1.15 11.59 1.15h2.44a2 2 0 0 0 .23 0 2 2 0 0 0 .22 0h2.47c4.14 0 7.67-1 11.57-1.15 3.9.11 7.44 1.15 11.59 1.15h.4l-.54-.94a65 65 0 0 0-8.37-.86h-2.46a2 2 0 0 0-.23 0 2 2 0 0 0-.25 0h-2.44c-4.15 0-7.67 1-11.57 1.13-3.91-.11-7.44-1.13-11.59-1.13h-1.31a2 2 0 0 0-.27 0h-.86a2 2 0 0 0-.23 0 2 2 0 0 0-.23 0h-2.47c-4.15 0-7.69 1-11.59 1.13-3.9-.11-7.44-1.13-11.59-1.13h-1.31a3 3 0 0 0-.29 0h-.86a2 2 0 0 0-.23 0 2 2 0 0 0-.22 0h-2.47c-4.15 0-7.67 1-11.57 1.13-3.9-.11-7.42-1.13-11.57-1.13h-2.46a2 2 0 0 0-.23 0 2 2 0 0 0-.24 0h-2.43c-4.15 0-7.68 1-11.59 1.13-3.9-.11-7.44-1.13-11.58-1.13h-1.32a2 2 0 0 0-.27 0h-.88a2 2 0 0 0-.23 0 1.3 1.3 0 0 0-.2 0h-2.49Zm0 1.54c-3.49 0-6.53.73-9.74 1l-.45.77h.94c4.15 0 7.65-1.05 11.55-1.16 3.9.11 7.44 1.16 11.59 1.16h5.37c4.15 0 7.69-1.05 11.59-1.16 3.9.11 7.47 1.16 11.61 1.16h5.36c4.15 0 7.67-1.05 11.57-1.16 3.9.11 7.42 1.16 11.57 1.16h5.4c4.15 0 7.69-1.05 11.59-1.16 3.9.11 7.44 1.16 11.59 1.16h5.36c4.14 0 7.67-1.05 11.57-1.16 3.9.11 7.44 1.16 11.59 1.16h1.23l-.48-.84a85 85 0 0 0-9.33-1h-5.34c-4.15 0-7.67 1-11.57 1.14-3.91-.11-7.44-1.14-11.59-1.14h-5.34c-4.15 0-7.69 1-11.59 1.14-3.9-.11-7.44-1.14-11.59-1.14h-5.38c-4.15 0-7.67 1-11.57 1.14-3.9-.11-7.42-1.14-11.57-1.14h-5.36c-4.15 0-7.68 1-11.59 1.14-3.9-.12-7.44-1.14-11.58-1.14h-5.39Zm0 1.55c-3.82 0-7.12.85-10.66 1.07l-.43.74h1.84c4.15 0 7.65-1 11.55-1.13 3.9.11 7.44 1.13 11.59 1.13h5.37c4.15 0 7.69-1 11.59-1.13 3.9.11 7.46 1.13 11.61 1.13h5.36c4.15 0 7.67-1 11.57-1.13 3.9.11 7.42 1.13 11.57 1.13h5.41c4.15 0 7.69-1 11.59-1.13 3.9.11 7.44 1.13 11.59 1.13h5.36c4.14 0 7.67-1 11.57-1.13 3.9.11 7.44 1.13 11.59 1.13h2.11l-.44-.77c-3.39-.25-6.59-1-10.26-1h-5.35c-4.14 0-7.66 1-11.56 1.13-3.91-.11-7.44-1.13-11.59-1.13h-5.34c-4.15 0-7.69 1-11.59 1.13-3.9-.11-7.44-1.13-11.59-1.13h-5.38c-4.15 0-7.67 1-11.57 1.13-3.9-.11-7.42-1.13-11.57-1.13h-4.04c-.15 0-1.37.07-2 .17s-7.24.83-10.87 1c-3.9-.11-7.44-1.13-11.58-1.13h-5.39Zm0 1.54c-4.14 0-7.67 1-11.57 1.13l-.39.68h2.73c4.15 0 7.65-1 11.55-1.13 3.9.11 7.44 1.13 11.59 1.13h5.35c4.15 0 7.69-1 11.59-1.13 3.9.11 7.46 1.13 11.61 1.13h5.36c4.15 0 7.67-1 11.57-1.13 3.9.11 7.42 1.13 11.57 1.13h5.41c4.15 0 7.69-1 11.59-1.13 3.9.11 7.44 1.13 11.59 1.13h5.36c4.14 0 7.67-1 11.57-1.13 3.9.11 7.44 1.13 11.59 1.13h3l-.4-.69c-3.75-.16-7.18-1.12-11.19-1.12h-5.35c-4.18 0-7.74 1-11.68 1.13-3.86-.13-7.36-1.13-11.47-1.13h-5.34c-4.15 0-7.69 1-11.59 1.13-3.9-.11-7.45-1.13-11.59-1.13h-5.38c-4.15 0-7.68 1-11.57 1.13-3.9-.11-7.42-1.13-11.57-1.13h-5.36c-4.1 0-7.61 1-11.46 1.13-3.95-.09-7.53-1.13-11.72-1.13h-5.38Zm0 1.55c-4.14 0-7.67 1-11.57 1.13h-.88l-.42.73h3.62c4.15 0 7.65-1 11.55-1.14 3.9.11 7.44 1.14 11.59 1.14h5.37c4.15 0 7.69-1 11.59-1.14 3.9.11 7.46 1.14 11.61 1.14h5.36c4.15 0 7.67-1 11.57-1.14 3.9.11 7.42 1.14 11.57 1.14h5.41c4.15 0 7.69-1 11.59-1.14 3.9.11 7.44 1.14 11.59 1.14h5.36c4.14 0 7.67-1 11.57-1.14 3.9.11 7.44 1.14 11.59 1.14h3.9l-.41-.71h-.51c-3.9-.11-7.43-1.13-11.57-1.13h-5.35c-4.14 0-7.66 1-11.56 1.13-3.91-.11-7.44-1.13-11.59-1.13h-5.34c-4.15 0-7.69 1-11.59 1.13-3.9-.11-7.44-1.13-11.59-1.13h-5.38c-4.14 0-7.67 1-11.57 1.13-3.9-.11-7.42-1.13-11.57-1.13h-5.36c-4.15 0-7.68 1-11.59 1.13-3.9-.11-7.44-1.13-11.58-1.13h-5.39Zm0 1.54c-4.14 0-7.67 1-11.57 1.13-.59 0-1.16-.05-1.74-.1l-.44.76h4.5c4.15 0 7.65-1 11.55-1.13 3.9.11 7.44 1.13 11.59 1.13h5.37c4.15 0 7.69-1 11.59-1.13 3.9.11 7.46 1.13 11.61 1.13h5.36c4.15 0 7.67-1 11.57-1.13 3.9.11 7.42 1.13 11.57 1.13h5.41c4.15 0 7.69-1 11.59-1.13 3.9.11 7.44 1.13 11.59 1.13h5.36c4.14 0 7.67-1 11.57-1.13 3.9.11 7.44 1.13 11.59 1.13h4.78l-.44-.75c-.45 0-.9.07-1.36.08-3.9-.11-7.43-1.13-11.57-1.13h-5.35c-4.14 0-7.66 1-11.56 1.13-3.91-.11-7.44-1.13-11.59-1.13h-5.34c-4.15 0-7.69 1-11.59 1.13-3.9-.11-7.44-1.13-11.59-1.13h-5.38c-4.14 0-7.67 1-11.57 1.13-3.9-.11-7.42-1.13-11.57-1.13h-5.36c-4.15 0-7.68 1-11.59 1.13-3.9-.11-7.44-1.13-11.58-1.13h-5.39Zm0 1.54c-4.14 0-7.67 1-11.57 1.14-.88 0-1.72-.11-2.57-.21l-.51.88h5.4c4.15 0 7.65-1 11.55-1.12 3.9.11 7.44 1.12 11.59 1.12h5.36c4.15 0 7.69-1 11.59-1.12 3.9.11 7.46 1.12 11.61 1.12h5.36c4.15 0 7.67-1 11.57-1.12 3.9.11 7.42 1.12 11.57 1.12h5.38c4.15 0 7.69-1 11.59-1.12 3.9.11 7.44 1.12 11.59 1.12h5.36c4.14 0 7.67-1 11.57-1.12 3.9.11 7.44 1.12 11.59 1.12h5.75l-.48-.83c-.73.08-1.46.15-2.21.17-3.9-.11-7.43-1.14-11.57-1.14h-5.39c-4.14 0-7.66 1-11.56 1.14-3.91-.13-7.44-1.13-11.62-1.13h-5.31c-4.15 0-7.69 1-11.59 1.14-3.9-.11-7.44-1.14-11.59-1.14h-5.38c-4.14 0-7.67 1-11.57 1.14-3.92-.14-7.44-1.14-11.56-1.14h-5.36c-4.15 0-7.68 1-11.59 1.14-3.9-.11-7.44-1.14-11.58-1.14h-5.39Zm0 1.55c-4.14 0-7.67 1-11.57 1.13a32 32 0 0 1-3.4-.31l-.57 1h3.36a2 2 0 0 0 .24 0 2 2 0 0 0 .23 0h2.46c4.15 0 7.65-1 11.55-1.13 3.9.11 7.44 1.13 11.59 1.13h2.47a2 2 0 0 0 .22 0 2 2 0 0 0 .25 0h2.43c4.15 0 7.69-1 11.59-1.13 3.9.11 7.47 1.13 11.61 1.13H626a2 2 0 0 0 .22 0 2 2 0 0 0 .23 0h2.46c4.15 0 7.67-1 11.57-1.13 3.9.11 7.42 1.13 11.57 1.13h2.44a2 2 0 0 0 .23 0 2 2 0 0 0 .25 0h2.44c4.15 0 7.69-1 11.59-1.13 3.9.11 7.44 1.13 11.59 1.13H683a2 2 0 0 0 .23 0 2 2 0 0 0 .22 0h2.47c4.14 0 7.67-1 11.57-1.13 3.9.11 7.44 1.13 11.59 1.13h2.42a2 2 0 0 0 .23 0 2 2 0 0 0 .22 0h3.72l-.51-.89c-1 .12-2 .21-3.06.24-3.9-.11-7.43-1.13-11.57-1.13h-5.35c-4.14 0-7.66 1-11.56 1.13-3.91-.11-7.44-1.13-11.59-1.13h-5.34c-4.15 0-7.69 1-11.59 1.13-3.9-.11-7.44-1.13-11.59-1.13h-5.38c-4.14 0-7.67 1-11.57 1.13-3.9-.11-7.42-1.13-11.57-1.13h-5.36c-4.15 0-7.68 1-11.59 1.13-3.9-.11-7.44-1.13-11.58-1.13h-5.39Zm0 1.54c-4.14 0-7.67 1-11.57 1.13a39 39 0 0 1-4.24-.41l-.58 1c.58 0 1.17.08 1.78.08h5.36c4.15 0 7.65-1 11.55-1.14 3.9.11 7.44 1.14 11.59 1.14h5.37c4.15 0 7.69-1 11.59-1.14 3.9.11 7.47 1.14 11.61 1.14h5.36c4.15 0 7.67-1 11.57-1.14 3.9.11 7.42 1.14 11.57 1.14h5.4c4.15 0 7.69-1 11.59-1.14 3.9.11 7.44 1.14 11.59 1.14h5.36c4.14 0 7.67-1 11.57-1.14 3.9.11 7.44 1.14 11.59 1.14h5.29c.72 0 1.43-.05 2.13-.1l-.55-1a35 35 0 0 1-3.88.36c-3.9-.11-7.43-1.13-11.57-1.13h-5.35c-4.14 0-7.66 1-11.56 1.13-3.91-.1-7.44-1.13-11.59-1.13h-5.34c-4.15 0-7.69 1-11.59 1.13-3.9-.11-7.44-1.13-11.59-1.13h-5.38c-4.14 0-7.67 1-11.57 1.13-3.9-.11-7.42-1.13-11.57-1.13h-5.36c-4.15 0-7.68 1-11.59 1.13-3.9-.11-7.44-1.13-11.58-1.13h-4.69Z"
          style={{
            fill: "url(#Nicaragua_svg__linear-gradient-8)",
          }}
        />
        <g id="Nicaragua_svg__g4157">
          <g id="Nicaragua_svg__g4159">
            <path
              id="Nicaragua_svg__path4161"
              d="M622.33 357.38a4 4 0 0 0-.49 0v12.95c0 2.8 1 5.06 2.41 7.72.09.23.17.42.25.59.49 1.3.85 1.75 2.73 3.18 6 4.54 13.39 5.22 17.76 4.84-1.37-1.08-2.83-2.06-4.12-3a30.5 30.5 0 0 0 5.41-.61 27.7 27.7 0 0 1-11.71-7.33c-.59-.6-1.13-1.23-1.68-1.87-.25-.35-.6-.83-.71-1a42 42 0 0 1-3.77-5.41c-.42-.75-.82-1.5-1.2-2.27-.56-1.16-1.06-2.34-1.5-3.52-.14-.4-.29-.8-.42-1.2-.27-.8-.5-1.59-.71-2.39 0 0-.07-.15-.39-.35a2.6 2.6 0 0 0-.69-.28 4.3 4.3 0 0 0-1.13-.14Z"
              className="Nicaragua_svg__cls-16"
            />
          </g>
        </g>
        <g id="Nicaragua_svg__g4163">
          <path
            id="Nicaragua_svg__path4165"
            d="M623.17 359.1c.49 7.23 2.73 15.81 8 21.35 1.93 1.6 4.39 3.06 6.77 2.7-8.11-6.6-13-16.71-14.73-24Z"
            style={{
              fill: "#ccd11e",
            }}
          />
        </g>
        <path
          id="Nicaragua_svg__path4169"
          d="M628.16 369.1c2.84 7 10 13.54 17.44 17.93a27 27 0 0 0 3-.07c-5.26-2.84-13.79-6.9-20.44-17.86"
          className="Nicaragua_svg__cls-18"
        />
        <path
          id="Nicaragua_svg__path4133-8"
          d="M698.15 388.12h-.72c-3.88.11-6.67 1.34-13.42 1.34s-7.46-1.23-15.09-1.06c-7.13.16-10.12 1.51-14 1.46s-10.15-.83-15-.33-10.59 1.54-14.36 1.55c-4.68 0-9.37-.88-14.27-.39s-7.19 1.8-13.26 1.78c-5.22 0-10.89-.84-15.28-.83-4.12 0-8.71 1.15-12.09 1.73l-1 1.75c2.69-.31 10.25-1.46 13-1.53s12.84.58 18.38.39 6.18-1.4 12.73-1.4c4.56 0 8 .47 12.67.47 2.91 0 5.56-1.48 10-1.48.22-.1.48 0 .72 0l.59-.05h2c3.73-.62 10 0 14.44.28 4 .2 6.54-.74 10.68-.88h4.65l.72-.05c4.15-.13 7.7.77 11.6.75 3.9-.24 7.68-1.1 11.82-1.24h5.37a56 56 0 0 1 9.92.6l-1-1.74c-2.86-.09-6.37-.76-9.81-.76Z"
          style={{
            fill: "url(#Nicaragua_svg__linear-gradient-9)",
          }}
        />
        <path
          id="Nicaragua_svg__path4909-8-8"
          d="M695.62 385c-3.9.24-6.86.86-11 1h-4.52l-.84.05c-4.14.14-8.24-.52-12.15-.5-3.9.24-7.42 1.4-11.57 1.54H651l-.84.05c-4.15.14-7.68-.52-11.58-.5-3.89.24-7.41.59-11.55.73h-5.37c-4.14.14-7.73-.24-11.63-.22-3.9.24-7.42 1.13-11.57 1.26h-5.34c-4.15.14-7.7-.52-11.6-.5-3.81.24-4.38.75-8.2 1.5l-2.91 5c3.4-.56 8.52-2 12.75-2 4.39 0 9.69 1.08 14.91 1.1 6.07 0 8.36-1.3 13.26-1.78s9.59.63 14.27.65c3.77 0 9.52-1.31 14.36-1.81s9.27.35 15.1.44 6.75-1.42 13.88-1.57c7.63-.17 8.33 1 15.09 1 5.08.27 9.45-1 14-1.34a79 79 0 0 1 10 .13l-2.21-3.9h-.11c-4.14.14-6.11-1-10-1Z"
          className="Nicaragua_svg__cls-15"
        />
        <path
          id="Nicaragua_svg__path4196-7"
          d="M700.63 390s3.25.18 4.62.33 3.54.31 3.54.31l-.44-.58c-.69.2-5.3-.27-7.72-.06"
          className="Nicaragua_svg__cls-2"
        />
        <path
          id="Nicaragua_svg__path3961-5"
          d="m640.62 270.36-38.53 66.75-39.39 68.21h155.83L680 338.57Zm0 3.6 37.82 65.51 37 64H565.81L603.64 338l37-64.05Z"
          className="Nicaragua_svg__cls-3"
        />
        <g id="Nicaragua_svg__g4090-8">
          <path
            id="Nicaragua_svg__path4092-1"
            d="M642.39 359.1c.49 7.23 2.66 14.39 7.89 19.93 1.93 1.6 4.39 3.06 6.77 2.7-8.79-5.99-12.98-15.29-14.66-22.63"
            className="Nicaragua_svg__cls-17"
          />
        </g>
        <g id="Nicaragua_svg__g4419-5">
          <path
            id="Nicaragua_svg__path4433-7"
            d="M640.62 333.41h-.16l.16 3.73.16-3.73Zm-1.19.09h-.31l.67 3.66Zm2.37 0-.36 3.7.68-3.66Zm-3.69.25-.31.09 1.2 3.56Zm5 0-.88 3.65 1.19-3.56Zm-6.28.45-.29.13 1.66 3.31Zm7.56 0-1.39 3.45 1.67-3.32Zm-8.76.61-.27.17 2.12 3.06Zm10 0-1.87 3.19 2.1-3Zm-11.05.77-.24.2 2.51 2.73Zm12.15 0-2.28 2.94 2.52-2.73Zm-13.12.92-.21.24 2.86 2.34Zm14.1 0-2.71 2.58 2.84-2.33Zm-14.94 1.05c-.06.09-.12.18-.17.27l3.15 1.91Zm15.77 0-3 2.19 3.17-1.92ZM632 338.72c0 .09-.09.18-.13.28l3.38 1.46Zm17.15 0-3.28 1.75 3.42-1.46c-.01-.1-.05-.2-.1-.29ZM631.53 340l-.09.3 3.54 1Zm18.17 0-3.45 1.26 3.55-1c-.03-.1-.07-.2-.1-.26m-18.5 1.3-.06.3 3.62.46Zm18.84 0-3.56.76 3.61-.46c-.02-.14-.03-.24-.09-.34Zm-19 1.32v.31l3.68-.05Zm19.15 0-3.66.26 3.67.05c0-.14 0-.24-.01-.35Zm-15.45 1.09-3.66.25v.31Zm11.76 0 3.62.56v-.31Zm-11.62.81-3.58.76c0 .1.05.2.07.3Zm11.47 0 3.51 1.06c0-.1 0-.2.07-.3Zm-11.23.79-3.42 1.24.12.28Zm11 0 3.29 1.51c0-.09.08-.19.11-.28Zm-.39.73 3.06 2c.06-.09.11-.18.16-.27Zm-10.25 0-3.22 1.7.16.27Zm.46.69-2.94 2.1.19.24Zm9.34 0 2.75 2.36.19-.23Zm-8.78.6-2.62 2.53.22.21Zm8.21 0 2.41 2.73.22-.21Zm-7.57.52-2.26 2.87.25.18Zm6.94 0 2 3 .25-.18Zm-6.23.4-1.85 3.16.27.14Zm5.52 0 1.57 3.31.27-.14Zm-4.79.37-1.37 3.38.3.1Zm4 0 1.09 3.46.29-.1Zm-3.25.21-.9 3.53.3.06Zm2.45 0 .6 3.59.3-.06Zm-1.63.11-.41 3.62h.31Zm.82 0 .1 3.64h.31Z"
            className="Nicaragua_svg__cls-2"
          />
        </g>
        <path
          id="Nicaragua_svg__rect5577-4"
          d="M575.28 310.46h6.16v9.33h-6.16z"
          style={{
            fill: "red",
            fillOpacity: 0,
          }}
        />
        <g id="Nicaragua_svg__g3591-4">
          <g id="Nicaragua_svg__g3539-2">
            <path
              id="Nicaragua_svg__path3541-9"
              d="M641.09 346.19c-.77-.15-1.47-.58-2.13-.73a2.67 2.67 0 0 0-.88 2.49c.32.17.38.43 1.06 1s.59.92.55 2.35c0 .6.09 1.9.7 2s1.11-.42 1.3-1.39a5.8 5.8 0 0 1 .84-2c.37-2.2-.23-2.99-1.44-3.72"
              style={{
                fill: "#510000",
              }}
            />
            <g id="Nicaragua_svg__g3543-3">
              <g id="Nicaragua_svg__g3545-0">
                <g id="Nicaragua_svg__g3547-7">
                  <path
                    id="Nicaragua_svg__path3549-7"
                    d="M637.22 340.67c-.71 0-1.83 1.21-2.33.57a1.73 1.73 0 0 1 0-1.68 5.77 5.77 0 0 1 2.6-2.8c2.85-1.68 4.66-1.14 6.08 1.28 1.31 2.12 2.58 4.47 2.69 6.44 0 .6.34 1.68-.19 2.23-1.61 1.66-5.51-1.72-7.79-1.19-.76.18-1.65.74-2.37.26-.56-.37-.09-1.19.33-1.55a6.22 6.22 0 0 0 1.65-3.79c-.08-.54-.09.21-.63.23Z"
                    className="Nicaragua_svg__cls-5"
                  />
                  <path
                    id="Nicaragua_svg__path3551-8"
                    d="M636.93 339.5c-1.3.53-1.16 1.29-1.81 1.9a1.42 1.42 0 0 0 1.64-.36 3 3 0 0 1 .81-.43 8 8 0 0 0-.82.82 6.1 6.1 0 0 0-1.61 2.21 5.7 5.7 0 0 0-.45 2.14 3.46 3.46 0 0 0 1.88 1.47c2.43 1 2.9 2.93 5.37 2.93 1.93 0 1.62-1.27 3.17-1 1.34.23 2-.84.76-1.48-1.64-.56-4.91-.23-6.44 0-.5-4.89-.07-3.17-.18-5.28s-.75-2.23.08-3.93c-.69 1-1.53.88-2.4 1Z"
                    style={{
                      fill: "url(#Nicaragua_svg__linear-gradient-10)",
                    }}
                  />
                  <path
                    id="Nicaragua_svg__path3553-7"
                    d="M641.74 336.2a3 3 0 0 0-.07.71c.11.41.21.84.34 1.2a10 10 0 0 1 .28 1.11c.1.43.48.6.84.86s.1 1.25.37 1.28.59-1.28.59-1.49a5 5 0 0 0 0-.78c-.17-.35-.33-.7-.51-1a2.5 2.5 0 0 0-.23-.39 4.9 4.9 0 0 0-.94-1l-.07-.06-.31-.22a2 2 0 0 0-.23-.13Z"
                    style={{
                      fill: "#ff2a2a",
                    }}
                  />
                </g>
              </g>
              <g id="Nicaragua_svg__g3556-3">
                <path
                  id="Nicaragua_svg__path3560-3"
                  d="M642.11 345.31c-.86-.23-1.71-.65-2.44-.87-1.44-.43-3-1.36-4-1-.38.16-.35.54-.47 1.09s-.72 1.58-.16 1.27c.82-.46 3 .88 3.71 1.33a2.93 2.93 0 0 1 1.29 1.22 8.7 8.7 0 0 1 0 2.75c-.06.68.14 2.2.82 2.38s1.3-.38 1.58-1.47a7.1 7.1 0 0 1 .91-2.3 2.24 2.24 0 0 1 1.58-1c.68-.13 1.66.55 1.66-.24 0-.53-.46-1-.27-1.75.16-.56-.48-.45-1-.68-1.23-.38-2.32-.51-3.21-.73"
                  style={{
                    fill: "url(#Nicaragua_svg__linear-gradient-11)",
                  }}
                />
                <path
                  id="Nicaragua_svg__path3562-8"
                  d="M638.65 347.11c-.39-.21-2.77-1.77-3.64-1.28-.28.15-.39 0-.39-.31a4.7 4.7 0 0 1 .22-1 2.6 2.6 0 0 1 .62-1.27c.82-.7 2.72.69 3.73 1.06-.09.52-.57 2.83-.54 2.84Z"
                  style={{
                    fill: "#910000",
                  }}
                />
              </g>
            </g>
          </g>
          <g id="Nicaragua_svg__g3974">
            <path
              id="Nicaragua_svg__path3587-2"
              d="M642.73 350.06c1.1-1.92 1.81-1.67 3.13-1.65.44 0 .57-.39.47-.8-.33.75-2-.08-2.89.32-1.89.83-1.54 4.52-2.43 4.88.93.78 1.35-2.09 1.72-2.75"
              style={{
                fill: "#ff3a3a",
              }}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgNicaragua;
